import styled from 'styled-components';

import { Flexer } from '@ontruck/orc';

const StyledRefreshWrapper = styled(Flexer.Parent).attrs(() => ({ alignItems: 'center' }))`
  position: absolute;
  top: 10px;
  right: 10px;
  background: transparent;
`;

export { StyledRefreshWrapper };
